import { render, staticRenderFns } from "./PopupError.vue?vue&type=template&id=8d5a5b96&scoped=true&"
import script from "./PopupError.vue?vue&type=script&lang=js&"
export * from "./PopupError.vue?vue&type=script&lang=js&"
import style0 from "./PopupError.vue?vue&type=style&index=0&id=8d5a5b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a5b96",
  null
  
)

export default component.exports